export const GROUP_DIVIDER = '-nestedGroups-';
export const RESULT_FIELD_ID_PARTS_DIVIDER = '___';
export const RESULT_GROUP_DIVIDER = '-resultGroup-';
